import { replaceEmptyOrUndefinedWithNull } from "utils/utils";

const serviceGeneralName = "/Resume";
const serviceSpecificLanguageName = "/ResumeLanguage"
const serviceSpecificSkillName = "/ResumeSkill"
const serviceSpecificTrainingName = "/ResumeTraining"
const serviceSpecificMembershipName = "/ResumeMembership"
const serviceSpecificAboutMeName = "/ResumeAboutMe"
const serviceSpecificPublicationName = "/ResumePublication"
const serviceSpecificExperienceName = "/ResumeExperience"
const serviceSpecificEducationName = "/ResumeEducation"

// const serviceSpecificExperienceFromHrName = "/ResumeExperienceFromHr"
// const serviceSpecificEducationFromHrName = "/ResumeEducationFromHr"




export function resumeService(http) {
    return {
        
        getAllResumeInformation: (generalId) => {
            let params = {
                GeneralId: generalId
            }
            return http.post(serviceGeneralName + "/GetPersonnelAllResumeInformation", params);
        },

        // ----- Language Section
        getLanguages: (generalId) => {
            let params = {
                GeneralId: generalId
            }
            return http.post(serviceGeneralName + "/GetResumeLanguages", params);
        },
        confirmLanguages: languages => {
            return http.post(serviceGeneralName + "/ConfirmLanguages", languages);
        },
        confirmSkills: skills => {
            return http.post(serviceGeneralName + "/ConfirmSkills", skills);
        },
        confirmPublications: publications => {
            return http.post(serviceGeneralName + "/ConfirmPublications", publications);
        },        
        confirmExperiences: experiences => {
            return http.post(serviceGeneralName + "/ConfirmExperiences", experiences);
        },
        // confirmExperiencesFromHr: experiences => {
        //     return http.post(serviceGeneralName + "/ConfirmExperiencesFromHr", experiences);
        // },        
        confirmMemberships: memberships => {
            return http.post(serviceGeneralName + "/ConfirmMemberships", memberships);
        },
        confirmAboutMe: aboutMe => {
            return http.post(serviceGeneralName + "/ConfirmAboutMe", aboutMe);
        },        
        confirmTrainings: trainings => {
            return http.post(serviceGeneralName + "/ConfirmTrainings", trainings);
        },                  
        // confirmEducationFromHr: educations => {
        //     return http.post(serviceGeneralName + "/ConfirmEducations", educations);
        // },
        confirmEducation: educations => {
            return http.post(serviceGeneralName + "/ConfirmEducations", educations);
        },        
        confirmAllResume: (generalIds, approvalPersonnelId) => {
            return http.post(serviceGeneralName + "/ConfirmPersonnelAllResume", {
                generalIds,
                approvalPersonnelId
            });
        },
        addNewLanguage: (generalId, languageId, languageProficiencyId) => {
            let params = {
                GeneralId: generalId,
                LanguageId: parseInt(languageId),
                LanguageProficiencyId: parseInt(languageProficiencyId)
            }
            return http.post(serviceSpecificLanguageName + "/AddNewLanguage", params);
        },
        getUserLanguageCount: (generalId, languageId) => {
            return http.get(serviceSpecificLanguageName + `/GetUserLanguageCount?generalId=${generalId}&languageId=${languageId}`);
        },                
        updateLanguage: (id, generalId, languageId, languageProficiencyId) => {
            let params = {
                Id: id,
                GeneralId: generalId,
                LanguageId: parseInt(languageId),
                languageProficiencyId
            }
            return http.post(serviceSpecificLanguageName + "/UpdateLanguage", params);
        },
        deleteLanguage: (generalId, languageId) => {
            let params = {
                GeneralId: generalId,
                LanguageId: parseInt(languageId)
            }
            return http.post(serviceSpecificLanguageName + "/DeleteLanguage", params);
        },
        insertionValidation: (generalId, languageId) => {
            let message = {
                generalId: generalId,
                languageId: parseInt(languageId)
            }
            return http.post(serviceSpecificLanguageName + "/InsertionValidation", message);
        },

        // ----- Publication Section
        getPublications: (generalId) => {
            let params = {
                GeneralId: generalId
            }
            return http.post(serviceGeneralName + "/GetResumePublications", params);
        },
        addNewPublicationAsync: async(generalId, description, englishDescription, systemTranslation) => {
            let params = {
                generalId,
                description,
                englishDescription,
                systemTranslation
            };

            return await http.post(serviceSpecificPublicationName + "/AddNewPublicationAsync", params);
        },
        updatePublicationAsync: async (id, generalId, description, englishdescription, isApproved, approvalDate, approvalPersonnelId, systemTranslation) => {
            let params = {
                id,
                generalId,
                description,
                englishdescription,
                isApproved,
                approvalDate,
                approvalPersonnelId,
                systemTranslation
            }
            return await http.post(serviceSpecificPublicationName + "/UpdatePublicationAsync", params);
        },
        deletePublication: (generalId, membershipId) => {
            let params = {
                Id: membershipId,
                GeneralId: generalId,
            }
            return http.post(serviceSpecificPublicationName + "/DeletePublication", params);
        },
        insertionPublicationValidation: (generalId, description) => {
            let params = {
                GeneralId: generalId,
                Description: description
            }
            return http.post(serviceSpecificPublicationName + "/InsertionValidation", params);
        },

        // ----- Skills Section
        getSkills: (generalId) => {
            let params = {
                GeneralId: generalId
            }
            return http.post(serviceGeneralName + "/GetResumeSkills", params);
        },
        addNewSkillAsync: async(generalId, description, englishDescription, systemTranslation) => {
            let params = {
                GeneralId: generalId,
                Description: description,
                englishDescription,
                systemTranslation
            }
            return await http.post(serviceSpecificSkillName + "/AddNewSkillAsync", params);
        },
        updateSkillAsync: async(id, generalId, description, englishDescription, isApproved, approvalDate, approvalPersonnelId, systemTranslation) => {
            var params = {
                id,
                generalId,
                description,
                englishDescription,
                isApproved,
                approvalDate,
                approvalPersonnelId,
                systemTranslation
            }
            return await http.post(serviceSpecificSkillName + "/UpdateSkillAsync", params);
        },
        deleteSkill: (generalId, skillId) => {
            var params = {
                Id: skillId,
                GeneralId: generalId,
            }
            return http.post(serviceSpecificSkillName + "/DeleteSkill", params);
        },
        insertionSkillValidation: async (generalId, description) => {
            var params = {
                GeneralId: generalId,
                Description: description,
            }
            return await http.post(serviceSpecificSkillName + "/InsertionValidation", params);
        },

        // ----- Training Section

        getTrainings: (generalId) => {
            var params = {
                GeneralId: generalId
            }
            return http.post(serviceGeneralName + "/GetResumeTrainings", params);
        },
        addNewTrainingAsync: (params) => {
            //     debugger;
            // var params = {
            //     Id: 0,
            //     GeneralId: generalId,
            //     TotalHours: totalHours,
            //     Title: trainingTitle,
            //     TrainingDate: trainingDate,
            //     Location: location,
            //     Country: country,
            //     GeneralOrSpecialized: certificateType,
            //     HasCertificate: Boolean(hasCertificate)
            // }
            return http.post(serviceSpecificTrainingName + "/AddNewTrainingAsync", params);
        },
        updateTrainingAsync: async (params) => {
                // var params = {
                //     Id: Id,
                //     GeneralId: generalId,
                //     TotalHours: totalHours,
                //     Title: trainingTitle,
                //     TrainingDate: trainingDate,
                //     Location: location,
                //     Country: country,
                //     GeneralOrSpecialized: certificateType,
                //     HasCertificate: hasCertificate
                // }
            return await http.post(serviceSpecificTrainingName + "/UpdateTrainingAsync", params);
        },
        deleteTraining: (params) => {
            // var params = {
            //     Id: skillId,
            //     GeneralId: generalId,
            // }
            return http.post(serviceSpecificTrainingName + "/DeleteTraining", params);
        },
        insertionTrainingsValidation: (generalId, title, trainingDate) => {
            var params = {
                GeneralId: generalId,
                title: title, 
                trainingDate: trainingDate
            }
            return http.post(serviceSpecificTrainingName + "/InsertionValidation", params);
        },

        // ----- Experience From Hr Section
        getResumeExperiences: (generalId) => {
            var params = {
                GeneralId: generalId
            }
            return http.post(serviceGeneralName + "/GetResumeExperiences", params);
        },
        addNewExperienceAsync: async (generalId, fromDate, toDate,company, englishCompany, project, englishProject, position,
            englishPosition, country, englishCountry, remark, englishRemark, toPresent, isApproved, systemTranslation) => {
            let params = {
                generalId,
                fromDate,
                toDate,
                company,
                englishCompany,
                project,
                englishProject,
                position,
                englishPosition,
                country,
                englishCountry,
                remark,
                englishRemark,
                toPresent,
                isApproved,
                systemTranslation
            }
            return await http.post(serviceSpecificExperienceName + "/AddNewExperienceAsync", params);
        },
        updateExperienceAsync: async (
            id, generalId, fromDate, toDate,company, englishCompany , project, englishProject, position,
            englishPosition, country, englishCountry, remark, englishRemark , toPresent, isApproved, approvalDate, approvalPersonnelId, systemTranslation) => {
                let params = {
                    Id: id,
                    GeneralId: generalId,
                    FromDate: fromDate,
                    ToDate: toDate,
                    Company: company,
                    EnglishCompany: englishCompany,
                    Project: project,
                    EnglishProject: englishProject,
                    Position: position,
                    EnglishPosition: englishPosition,
                    Country: country,
                    EnglishCountry: englishCountry,
                    Remark: remark,
                    EnglishRemark: englishRemark,
                    ToPresent: toPresent,
                    IsApproved: isApproved,
                    approvalDate,
                    approvalPersonnelId,
                    systemTranslation

                }
            return await http.post(serviceSpecificExperienceName + "/UpdateExperienceAsync", params);
        },
        deleteExperience: (id, generalId) => {
            var params = {
                Id: id,
                GeneralId: generalId,
            }
            return http.post(serviceSpecificExperienceName + "/DeleteExperience", params);
        },
        insertionExperienceValidation: (generalId, fromDate, toDate, company) => {
            var params = {
                GeneralId: generalId,
                FromDate: fromDate,
                ToDate: toDate,
                Company: company
            }
            return http.post(serviceSpecificExperienceName + "/InsertionValidation", params);
        },

        // ------ About me
        getAboutMe: (generalId) => {
            var params = {
                GeneralId: generalId
            }
            return http.post(serviceGeneralName + "/GetAboutMe", params);
        },
        addNewAboutMeAsync : async (generalId, description, englishDescription, translate) => {
            var params = {
                GeneralId: generalId,
                Description: description,
                EnglishDescription: replaceEmptyOrUndefinedWithNull(englishDescription),
                Translate: translate
            }
            return await http.post(serviceSpecificAboutMeName + "/AddNewAboutMeAsync", params);
        },
        updateAboutMeAsync: async (id, generalId, description, englishDescription, isApproved, approvalDate, approvalPersonnelId, systemTranslation) => {
            var params = {
                id,
                generalId,
                description,
                englishDescription,
                isApproved,
                approvalDate,
                approvalPersonnelId,
                systemTranslation
            }
            return await http.post(serviceSpecificAboutMeName + "/UpdateAboutMeAsync", params);
        },
        deleteAboutMe: (generalId, aboutMeId) => {
            var params = {
                Id: aboutMeId,
                GeneralId: generalId
            }
            return http.post(serviceSpecificAboutMeName + "/DeleteAboutMe", params);
        },
        insertionAboutMeValidation: (generalId, description) => {
            var params = {
                GeneralId: generalId,
                Description: description
            }
            return http.post(serviceSpecificAboutMeName + "/InsertionValidation", params);
        },        

        // ------ Membership
        getMemberships: (generalId) => {
            var params = {
                GeneralId: generalId
            }
            return http.post(serviceGeneralName + "/GetResumeMemberships", params);
        },
        addNewMembershipAsync: async(generalId, description, englishDescription, systemTranslation) => {
            let params = {
                GeneralId: generalId,
                Description: description,
                englishDescription,
                systemTranslation
            }
            return await http.post(serviceSpecificMembershipName + "/AddNewMembershipAsync", params);
        },
        updateMembershipAsync: async(id, generalId, description, englishDescription, isApproved, approvalDate, approvalPersonnelId, systemTranslation) => {
            var params = {
                Id: id,
                GeneralId: generalId,
                Description: description,
                EnglishDescription: englishDescription,
                IsApproved: isApproved,
                approvalDate,
                approvalPersonnelId,
                systemTranslation
            }
            return await http.post(serviceSpecificMembershipName + "/UpdateMembershipAsync", params);
        },
        deleteMembership: (generalId, membershipId) => {
            var params = {
                Id: membershipId,
                GeneralId: generalId,
            }
            return http.post(serviceSpecificMembershipName + "/DeleteMembership", params);
        },
        insertionMembershipValidation: (generalId, description) => {
            var params = {
                GeneralId: generalId,
                Description: description
            }
            return http.post(serviceSpecificMembershipName + "/InsertionValidation", params);
        },


        // addNewExperienceFromHrAsync: async (params) => {
        //     return await http.post(serviceSpecificExperienceFromHrName + "/AddNewExperienceAsync", params);
        // },
        // updateExperienceFromHrAsync: async (params) => {
        //     return await http.post(serviceSpecificExperienceFromHrName + "/UpdateExperienceAsync", params);
        // },
        // deleteExperienceFromHr: (params) => {
        //     return http.post(serviceSpecificExperienceFromHrName + "/DeleteExperience", params);
        // },
        // addNewEducationFromHrAsync: (params) => {
        //     return http.post(serviceSpecificEducationFromHrName + "/AddNewEducationAsync", params);
        // },
        // updateEducationFromHrAsync: async (params) => {
        //     return await http.post(serviceSpecificEducationFromHrName + "/UpdateEducationAsync", params);
        // },
        // deleteEducationFromHr: (params) => {
        //     return http.post(serviceSpecificEducationFromHrName + "/DeleteEducation", params);
        // },

        addNewEducationAsync: (params) => {
            return http.post(serviceSpecificEducationName + "/AddNewEducationAsync", params);
        },
        updateEducationAsync: async (params) => {
            return await http.post(serviceSpecificEducationName + "/UpdateEducationAsync", params);
        },
        deleteEducation: (params) => {
            return http.post(serviceSpecificEducationName + "/DeleteEducation", params);
        },

    }
}

